import axios from 'axios';

const API_BASE_URL = 'https://prp20-wa-orderlist-api01.azurewebsites.net/api';

/**
 * Formats a date string to DD.MM.YYYY format
 * @param {string} dateString - ISO date string
 * @returns {string} Formatted date string
 */
const formatDate = (dateString) => {
    if (!dateString) return '';

    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}.${month}.${year}`;
};

export const orderProductService = {

    getOrderProductList: async (filters) => {
        try {
            const response = await axios.get(`${API_BASE_URL}/OrderProductList/OrderProductListSelectTable`, {
                params: {
                    productId: filters.productId,
                    customerTypeId: filters.customerTypeId,
                    productOfferTypeId: filters.productOfferTypeId,
                    shippingAddressCountryId: filters.shippingAddressCountryId,
                    orderProductStatusId: filters.orderProductStatusId || 0,
                    sendAdvertisingMail: filters.sendAdvertisingMail,
                    shippingAddressLastname: filters.shippingAddressLastname,
                    providerId: filters.providerId,
                    pageNumber: filters.pageNumber
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching order product list:', error);
            throw error;
        }
    },


    mapToGridData: (data) => {
        return data.map(item => ({
            ID: item.orderProductId,
            Datum: formatDate(item.orderProductDt),
            Zeitschrift: item.productName,
            Angebotsart: item.productOfferType,
            Logistikpartner: item.logisticPartner,
            Lieferbeginn: item.shippingStart,
            "Folge-RG": item.subsequentBillingNo,
            Soll: item.statusUserStatus,
            Ist: item.statusProviderStatus,
            Lieferende: item.shippingEnd,
            Kunde: item.customerId,
            "K-E-Mail": item.customerEmail,
            Abopreis: item.price,
            "Währung-Code": item.currencyCode,
            "Währung-Symbol": item.currencySymbol,
            Zahlungsart: item.paymentType,
            Zahlungsrhythmus: item.paymentInterval,
            "Abodauer": item.orderProductSubscriptionDuration,
            "L-Anrede": item.shippingAddressTitle,
            "L-Vorname": item.shippingAddressFirstname,
            "L-Nachname": item.shippingAddressLastname,
            "L-Firma": item.shippingAddressCompany,
            "L-Strasse": item.shippingAddressStreet,
            "L-PLZ": item.shippingAddressZip,
            "L-Ort": item.shippingAddressCity,
            "L-LKZ": item.shippingAddressCountryCode,
            "L=R": item.shippingIsBillingAddress,
            Newsletter: item.sendAdvertisingMail
        }));
    }
};